import Validation from '../lib/validation'

import { defineMessages } from 'react-intl'

const messages = defineMessages({
  message: {
    id: 'validation.message',
    defaultMessage: 'Vyplňte zprávu.',
  },
  email: {
    id: 'validation.email',
    defaultMessage: 'Vyplňte email',
  },
  phone: {
    id: 'validation.phone',
    defaultMessage: 'Vyplňte telefon',
  },
  emailInvalid: {
    id: 'validation.emailInvalid',
    defaultMessage: 'Neplatný email.',
  },
})

export const validateCreate = data => {
  const validator = new Validation(data)
  validator.isRequired('message', messages.message)
  validator.isRequired('email', messages.email)
  validator.isRequired('phone', messages.phone)
  validator.isEmail('email', messages.emailInvalid)
  return validator.validate()
}



// WEBPACK FOOTER //
// ./src/common/messages/validations.js